import React from 'react'
import { TbLoader3 } from 'react-icons/tb'
const ClerkLoader = () => {
  return (
    <div className="w-full min-h-screen bg-[#131517] text-white flex justify-center py-20">
      <TbLoader3 className="text-white animate-spin h-14 w-auto" />
    </div>
  )
}

export default ClerkLoader
